import axios from "axios";

export const statService = {
  async rewared(fromDate, toDate, type) {
    return await axios.get(
      `/statistic/rewarded?fromTime=${fromDate}&toTime=${toDate}&type=${type}`
    );
  },
};
